var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.is_show)?_c('div',{staticClass:"to-top-container",on:{"click":_vm.scrollToTop}},[_c('img',{attrs:{"src":_vm.cc.bg,"alt":""}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }